import { z } from 'zod';

const EventsCoursesTypesQuery = z.array(z.object({
    Id: z.number(),
    CourseType: z.string(),
}));

export { EventsCoursesTypesQuery };